module.exports = __webpack_public_path__ + "img/header-preview.3006f31c.png";